import classNames from "classnames";
import { cloudflareImagesLoader, IsNodeStructure } from "@talladega/helpers";
import { BackgroundImageGroup } from "@talladega/types";

const DEFAULT_FORM_SELECTOR_BACKGROUND_WIDTH = 1000;

type Props = {
  backgroundImageGroup?: BackgroundImageGroup;
  baseDomain: string;
};

export const FormSelectorBackgroundImage = ({
  backgroundImageGroup,
  baseDomain,
}: Props) => {
  if (
    !backgroundImageGroup ||
    (backgroundImageGroup && !backgroundImageGroup?.image)
  ) {
    return null;
  }

  const { sourceUrl } =
    (IsNodeStructure(backgroundImageGroup?.image)
      ? backgroundImageGroup?.image?.node
      : backgroundImageGroup?.image?.[0]) ?? {};

  return (
    <>
      <div
        className={classNames(
          "relative hidden w-full flex-1 overflow-auto bg-center bg-no-repeat lg:basis-[40%] xl:flex",
          {
            "lg:bg-left": backgroundImageGroup?.imagePosition === "Right",
            "lg:bg-right": backgroundImageGroup?.imagePosition === "Left",
          }
        )}
      />

      <div
        className={classNames(
          "relative flex w-full flex-1 overflow-auto bg-contain bg-center bg-no-repeat lg:basis-[40%] lg:bg-cover xl:hidden xl:basis-[50%]",
          {
            "px-5 lg:bg-left lg:px-0 xl:px-5":
              backgroundImageGroup?.imagePosition === "Right",
            "px-5 lg:bg-right lg:px-0 xl:px-5":
              backgroundImageGroup?.imagePosition === "Left",
          }
        )}
        style={
          sourceUrl
            ? {
                backgroundImage: `url(${cloudflareImagesLoader({
                  src: sourceUrl,
                  width: DEFAULT_FORM_SELECTOR_BACKGROUND_WIDTH,
                  baseDomain,
                })})`,
              }
            : {}
        }
      >
        <div className="relative inset-0 h-auto min-w-full">
          <div className="relative h-[15rem] overflow-auto md:h-[32rem]" />
        </div>
      </div>
    </>
  );
};

export default {};
